<script>
  import { onMount, setContext } from 'svelte'
  import './styles/_variables.css'
  import './styles/fonts.css'
  import './styles/core.css'
  import Modal from 'svelte-simple-modal'
  import Photoswipe from './components/Photoswipe'
  import ScrollerPage from './features/ScrollerPage'
  import { Trip } from './models';

  let trip = new Trip()

  setContext('config', { mapboxAccessToken: process.env.MAPBOX_ACCESS_TOKEN })

  onMount(async () => {
    const res = await fetch('data.json')
    const tripData = await res.json()
    trip = Trip.fromJson(tripData)
  })
</script>

<svelte:head>
  <title>{trip.title ?? 'My Trip'}</title>
</svelte:head>
<Photoswipe>
  <Modal>
    <main>
      {#if trip.waypoints.length > 0}
        <ScrollerPage {trip} />
      {/if}
    </main>
  </Modal>
</Photoswipe>
